import routesAccount from './routesAccount'
import Home from '../views/Home'
import RestaurantsList from '../views/RestaurantsList'
import Restaurant from '../views/Restaurant'
import MenuList from '../views/MenuList'
import NewsList from '../views/NewsList'
import News from '../views/News'
import Vacancies from '../views/Vacancies'
import Archive from '../views/Archive'
import Contacts from '../views/Contacts'
import Delivery from '../views/Delivery'
import E404 from '../views/E404'
import Product from '../views/Product'
import RestorePassword from '../views/RestorePassword'
import Basket from '../views/Basket'
import Guide from '../views/Guide'
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import PublicOffer from "../views/PublicOffer.vue";

const routes = [
  {
    path: '',
    name: 'home',
    component: Home,
    meta: {
      pageId: 30
    }
  },
  {
    path: 'restaurants-list',
    name: 'restaurants-list',
    component: RestaurantsList
  },
  {
    path: 'menu-list',
    name: 'menu-list',
    component: MenuList
  },
  {
    path: 'restaurant/:categoryId/:id',
    name: 'restaurant-with-category',
    component: Restaurant
  },
  {
    path: 'restaurant/:slug',
    name: 'restaurant',
    component: Restaurant
  },
  {
    path: 'menu/:categoryId/:id',
    name: 'menu-with-category',
    component: Restaurant
  },
  {
    path: 'menu/:slug',
    name: 'menu',
    component: Restaurant
  },
  {
    path: 'news/:categoryId?',
    name: 'news-list',
    component: NewsList
  },
  {
    path: 'news/news-page/:newsId',
    name: 'news',
    component: News
  },
  {
    path: 'vacancies',
    name: 'vacancies',
    component: Vacancies,
    meta: {
      pageId: 28
    }
  },
  {
    path: 'archive/:id',
    name: 'archive',
    component: Archive,
  },
  {
    path: 'contacts',
    name: 'contacts',
    component: Contacts,
    meta: {
      pageId: 29
    }
  },
  {
    path: 'delivery/:restaurantId/:categorySlug?',
    name: 'delivery',
    component: Delivery,
  },
  {
    path: 'product/:slug',
    name: 'product',
    component: Product,
  },
  {
    path: 'change-password',
    name: 'restore-password',
    component: RestorePassword,
  },
  {
    path: 'basket',
    name: 'basket',
    component: Basket
  },
  {
    path: 'privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy,
    meta: {
      pageId: 31
    }
  },
  {
    path: 'public-offer',
    name: 'public-offer',
    component: PublicOffer,
    meta: {
      pageId: 35
    }
  },
  ...routesAccount,
]

if (process.env.NODE_ENV !== 'production') {
  routes.push(
    {
      path: 'guide',
      name: 'guide',
      component: Guide,
    }
  )
}

routes.push(
  {
    path: '*',
    name: 'E404',
    component: E404
  }
)


export default routes
